import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import SplitText from 'gsap/SplitText'
import { mapState } from 'pinia';
import { getSmoother } from 'utils/ScrollSmootherInstance.js';
import matchMediaConfig from 'utils/matchMedia.js'

gsap.registerPlugin(ScrollTrigger, SplitText);
gsap.registerEase("easeInOutCubic", [0.42, 0, 0.21, 0.99]);
import { useScrollStore } from "stores/scroll";
export default {
	data() {
		return {
			blockText: null,
			blockTitle: null,
			blockTitleMedia: null,
			splitText: null,
			splitTitle: null,
			splitTitleMedia: false,
			hasAnimatedText: false,
			hasAnimatedTitle: false,
			hasAnimatedTitleMedia: false
		}
	},
	methods: {
		animateTitle() {
			if (this.hasAnimatedTitle) return;

			if (this.splitTitle) {
				this.splitTitle.revert();
			}
			gsap.set(this.blockTitle, { opacity: 1 });

			this.splitTitle = new SplitText(this.blockTitle, {
				type: "lines",
				linesClass: "line",
				autoSplit: true,
			})
			gsap.from(this.splitTitle.lines, {
				duration: 1.2,
				yPercent: 100,
				opacity: 0,
				stagger: 0.2,
				ease: "easeInOutCubic",
				onComplete: () => {
					this.hasAnimatedTitle = true;
				}
			})
		},
		animateText() {
			if (this.hasAnimatedText) return;

			if (this.splitText) {
				this.splitText.revert();
			}
			gsap.set(this.blockText, { opacity: 1 });

			this.splitText = new SplitText(this.blockText, {
				type: "lines",
				linesClass: "line",
				autoSplit: true,
			})
			gsap.from(this.splitText.lines, {
				duration: 1.2,
				yPercent: 100,
				opacity: 0,
				stagger: 0.2,
				ease: "easeInOutCubic",
				onComplete: () => {
					this.hasAnimatedText = true;
				}
			})
		},
		initAnimations() {
			const mm = gsap.matchMedia()
			mm.add(matchMediaConfig, (context) => {
				const { isDesktop, isMobile } = context.conditions
				context.add(() => {
					const wrapper = document.querySelector('.animation-section4');
					const blocks = document.querySelectorAll('.animation-section4 .block');
					this.blockTitleMedia = document.querySelector('.mediacenter-banner__title');
					this.blockTitle = document.querySelector('.vacancies__title');
					this.blockText = document.querySelector('.vacancies__text');
					const blockHeight = blocks[0].offsetHeight;
					const headerHeight = document.querySelector('header').offsetHeight;
					const smoother = getSmoother();

					gsap.to(blocks[0], {
						opacity: 0,
						duration: 1.6,
						ease: "easeInOutCubic",
						scrollTrigger: {
							trigger: blocks[0],
							start: `top top`,
							end: `bottom ${headerHeight}px`,
							scrub: true
						}
					});
					ScrollTrigger.create({
						trigger: blocks[0],
						start: `top bottom`,
						end: `top ${headerHeight}px`,
						onEnter: () => {
							if (this.hasAnimatedTitleMedia) return;

							if (this.splitTitleMedia) {
								this.splitTitleMedia.revert();
							}
							gsap.set(this.blockTitleMedia, { opacity: 1 });

							this.splitTitleMedia = new SplitText(this.blockTitleMedia, {
								type: "lines",
								linesClass: "line",
								autoSplit: true,
								mask: true
							})
							gsap.from(this.splitTitleMedia.lines, {
								duration: 0.8,
								yPercent: 200,
								opacity: 0,
								stagger: 0.1,
								ease: "easeInOutCubic",
								onComplete: () => {
									this.hasAnimatedTitleMedia = true;
								}
							})
						}
					})
					if (isDesktop) {
						//TODO ANIMATION

						if (this.getScrollEnabled && true) {
							// настройки для автоматического скролла блока вниз
							ScrollTrigger.create({
								trigger: blocks[0],
								start: `bottom ${headerHeight}px`,
								// start: this.scrollUpPosition,
								markers: false,
								id: "block8-1",
								end: `top ${headerHeight}px`,
								onLeaveBack: () => {
									if (this.getScrollDirection === 'up') {
										gsap.to(smoother, {
											scrollTop: Math.min(
												ScrollTrigger.maxScroll(window),
												smoother.offset(blocks[0], `top ${headerHeight}px`)
											),
											duration: 1.2,
											ease: "smoother",
											onStart: () => {
												smoother.smooth(0.1);
												smoother.paused(true)
											},
											onComplete: () => {
												smoother.paused(false)
												smoother.smooth(3);
											}
										});
									}
								},
							})
						}

						//TODO ANIMATION
						if (this.getScrollEnabled && true) {
							// настройки для автоматического скролла блока вверх
							ScrollTrigger.create({
								trigger: blocks[0],
								start: "25% bottom",
								id: "block8-2",
								markers: false,
								// start: this.scrollDownPosition,
								end: `top ${headerHeight}px`,
								onEnter: () => {
									if (this.getScrollDirection === 'down') {
										gsap.to(smoother, {
											scrollTop: Math.min(
												ScrollTrigger.maxScroll(window),
												smoother.offset(blocks[0], `top ${headerHeight}px`)
											),
											duration: 1.2,
											ease: "smoother",
											onStart: () => {
												smoother.smooth(0.1);
												smoother.paused(true)
											},
											onComplete: () => {
												smoother.paused(false)
												smoother.smooth(3);
											}
										});
									}
								},
							});
						}

						//TODO ANIMATION
						if (this.getScrollEnabled && true) {
							// настройки для автоматического скролла блока вверх
							ScrollTrigger.create({
								trigger: blocks[1],
								start: `top ${headerHeight + blockHeight}px`,
								id: "block8-3",
								markers: false,
								// start: this.scrollDownPosition,
								onEnter: () => {
									if (this.getScrollDirection === 'down') {
										gsap.to(smoother, {
											scrollTop: Math.min(
												ScrollTrigger.maxScroll(window),
												smoother.offset(blocks[1], `top ${headerHeight}px`)
											),
											duration: 1.2,
											ease: "smoother",
											onStart: () => {
												smoother.smooth(0.1);
												smoother.paused(true)
											},
											onComplete: () => {
												smoother.paused(false)
												smoother.smooth(3);
											}
										});
									}
								},
							});
						}

						ScrollTrigger.create({
							trigger: blocks[1],
							start: `top bottom`,
							end: `top ${headerHeight}px`,
							onEnter: () => {
								this.animateTitle();
								// setTimeout(() => {
								// 	this.animateText();
								// }, 100);
							}
						})

						ScrollTrigger.create({
							trigger: blocks[1],
							start: `top 80%`,
							// end: `top ${headerHeight}px`,
							onEnter: () => {
								this.animateText();
							}
						})
					}

					if (isMobile) {
						ScrollTrigger.create({
							trigger: blocks[1],
							start: `top bottom`,
							end: `top ${headerHeight}px`,
							onEnter: () => {
								this.animateTitle();
								setTimeout(() => {
									this.animateText();
								}, 100);
							}
						})
						gsap.to(wrapper, {
							duration: 1,
							background: "#e21a1a",
							ease: "easeInOutCubic",
							scrollTrigger: {
								trigger: blocks[1],
								start: `top ${headerHeight}px`,
								end: `bottom bottom`,
								scrub: true
							}
						});

						//TODO ANIMATION
						// if (this.getScrollEnabled && true) {
						// 	// настройки для автоматического скролла блока вверх
						// 	ScrollTrigger.create({
						// 		trigger: blocks[1],
						// 		start: `25% bottom`,
						// 		id: "block8-3",
						// 		markers: false,
						// 		// start: this.scrollDownPosition,
						// 		onEnter: () => {
						// 			if (this.getScrollDirection === 'down') {
						// 				gsap.to(smoother, {
						// 					scrollTop: Math.min(
						// 						ScrollTrigger.maxScroll(window),
						// 						smoother.offset(blocks[1], `top ${headerHeight}px`)
						// 					),
						// 					duration: 1.2,
						// 					ease: "smoother",
						// 					onStart: () => {
						// 						smoother.smooth(0.1);
						// 						smoother.paused(true)
						// 					},
						// 					onComplete: () => {
						// 						smoother.paused(false)
						// 						smoother.smooth(3);
						// 					}
						// 				});
						// 			}
						// 		},
						// 	});
						// }
					}
				})
			})
		},
		killAnimations() {
			if (this.splitText) {
				this.splitText.revert();
			}
			if (this.splitTitle) {
				this.splitTitle.revert();
			}

			ScrollTrigger.getAll().forEach(trigger => trigger.kill());
		}
	},
	computed: {
		...mapState(useViewportStore, ["getIsMobileState"]),
		...mapState(usePageAnimationStore, ["getPageCanAnimateBlocks", "getScrollDirection"]),
		...mapState(useScrollStore, ["getScrollEnabled", "scrollUpPosition", "scrollDownPosition"]),
	},
	mounted() {
		this.$nextTick(() => {
			if (this.getPageCanAnimateBlocks) {
				this.initAnimations();
			}
		});
	},
	beforeUnmount() {
		this.killAnimations();
	},
	watch: {
		getPageCanAnimateBlocks(state) {
			if (state) {
				this.initAnimations();
			}
		},
	}
}
